<template>
  <v-data-table
    :headers="headers"
    :items="meals"
    :search="search"
    :loading="isLoading"
    :loading-text="$t('loading_data')"
    class="ordera-box-shadow striped-table"
    mobile-breakpoint="0"
    dense
  >
    <template v-for="values in headers" v-slot:[`item.${values.value}`]="{ item }">
      <span v-if="values.value == 'for_sale'">
        <v-checkbox
          v-model="item[values.value]"
          @change="forSale(item, index)"
        ></v-checkbox>
      </span>
      <span v-else-if="values.value == 'image_id'">
        <span style="position: relative" class="row">
          <input
            style="cursor: pointer; position: relative; z-index: 999"
            type="file"
            id="upload"
            @change="upload(item, $event)"
          />
          <span
            style="position: absolute; left: 5px; z-index: 0; top: -9px"
            v-if="!item.image"
          >
            <v-icon style="font-size: 51px" small>mdi-image</v-icon>
          </span>
          <label style="position: absolute; top: -16px" v-else class="ma-3" for="upload">
            <v-img
              height="40"
              width="40"
              v-if="item.image && item.image.name == 'no-image.png'"
              :src="item.image.url"
            />
            <v-img height="40" v-else width="40" :src="galleryUrl(item.image.name)" />
            <a
              style="
                position: absolute;
                top: -8px;
                right: -7px;
                background: #c50b0b;
                color: #fff;
                font-size: 10px;
                padding: 1px 5px;
                border-radius: 15px;
                text-decoration: none;
              "
              @click.prevent="removeImage(item)"
              href=""
              :title="$t('remove_image')"
              >X</a
            >
          </label>
        </span>
      </span>
      <span v-if="values.value != 'for_sale' && values.value != 'image_id'">
        {{ translate(item[values.value]) }}
      </span>
    </template>
    <template v-slot:item.category="{ item }">
      {{ item && item.category ? toLatin(item.category.name) : "" }}
    </template>
    <template v-slot:item.sizes="{ item }">
      {{ item.sizes && item.sizes.name ? toLatin(item.sizes.name) : "" }}
    </template>
    <template v-slot:item.name="{ item }">
      {{ toLatin(item.name) }}
    </template>
    <template v-slot:item.groceries="{ item }">
      <td class="text-body-2">
        <template v-for="grocery in item.groceries">
          {{ grocery.name }}: {{ grocery.pivot?.quantity }} {{ grocery.measure }}<br />
        </template>
      </td>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row no-gutters justify="end">
        <circle-button
          class="mr-2"
          @click="showQr(item)"
          icon="mdi-qrcode"
          :tooltip="$t('tooltip_show_meal_qr')"
        ></circle-button>

        <circle-button
          class="mr-2"
          color="primary"
          icon="mdi-printer"
          @click="print(item)"
          :tooltip="$t('tooltip_print_qr')"
        ></circle-button>
        <edit-button class="mr-2" @click="$parent.editMeal(item)"></edit-button>
        <remove-button @click="$parent.deleteMeal(item)"></remove-button>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import mealActions from "@/mixins/mealActions";
import hasPrinting from "@/mixins/hasPrinting";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  name: "MealsTableView",
  mixins: [mealActions, hasPrinting, hasSnackbar],
  props: {
    meals: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: "",
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("id_pr"), value: "id", sortable: true },
        { text: this.$t("image"), align: "start", value: "image_id" },
        { text: this.$t("title"), align: "start", value: "name" },
        { text: this.$t("price"), value: "price" },
        { text: this.$t("group"), value: "category" },
        { text: this.$t("normativ"), value: "groceries" },
        { text: this.$t("s_v"), value: "for_sale" },
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          width: "13%",
        },
      ];
    },
  },
  methods: {
    translate(value) {
      if (typeof value === "string" || value instanceof String) {
        return this.$t(value) ? this.$t(value) : value;
      }
      return value;
    },
  },
};
</script>

<style scoped>
::file-selector-button {
  display: none;
}

input[type="file"] {
  display: inline-block;
  width: 40px;
  padding: 30px 0 0 0;
  height: 30px;
  overflow: hidden;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
</style>
